import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "oxd-calendar-header" }
const _hoisted_2 = { class: "oxd-calendar-selector" }
const _hoisted_3 = { class: "oxd-calendar-selector-month-selected" }
const _hoisted_4 = { class: "oxd-calendar-selector-year-selected" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_text = _resolveComponent("oxd-text")!
  const _component_oxd_calendar_dropdown = _resolveComponent("oxd-calendar-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_oxd_icon, {
      name: "chevron-left",
      onClick: _ctx.gotoPreviousMonth
    }, null, 8, ["onClick"]),
    _createElementVNode("ul", _hoisted_2, [
      _createVNode(_component_oxd_calendar_dropdown, {
        options: _ctx.months,
        selected: _ctx.currentMonth,
        onSelect: _ctx.onSelectMonth,
        class: "oxd-calendar-selector-month"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_oxd_text, { tag: "p" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.months[_ctx.modelValue.month]), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_oxd_icon, {
              name: "caret-down-fill",
              "with-container": false
            })
          ])
        ]),
        _: 1
      }, 8, ["options", "selected", "onSelect"]),
      _createVNode(_component_oxd_calendar_dropdown, {
        options: _ctx.years,
        selected: _ctx.currentYear,
        onSelect: _ctx.onSelectYear,
        class: "oxd-calendar-selector-year"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_oxd_text, { tag: "p" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.modelValue.year), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_oxd_icon, {
              name: "caret-down-fill",
              "with-container": false
            })
          ])
        ]),
        _: 1
      }, 8, ["options", "selected", "onSelect"])
    ]),
    _createVNode(_component_oxd_icon, {
      name: "chevron-right",
      onClick: _ctx.gotoNextMonth
    }, null, 8, ["onClick"])
  ]))
}